/**
 * Price Range Checkboxes
 * Provides quick preset filters that navigate to filtered URLs
 */
(function() {
  console.log('[Price Range Checkboxes] Script loaded');
  
  function enhancePriceRange() {
    const priceRangeElements = document.querySelectorAll('price-range[data-has-checkboxes="true"]');
    console.log('[Price Range Checkboxes] Found elements:', priceRangeElements.length);
    
    priceRangeElements.forEach((priceRange) => {
      // Remove old enhancement flag to allow re-binding after AJAX updates
      // We'll use a different approach - clone detection
      const checkboxes = priceRange.querySelectorAll('.price-range-preset');
      console.log('[Price Range Checkboxes] Found checkboxes:', checkboxes.length);
      
      if (!checkboxes.length) return;
      
      // Handle checkbox clicks - simply navigate to the filter URL
      checkboxes.forEach((checkbox, index) => {
        // Remove old listeners by cloning (prevents duplicate listeners)
        const newCheckbox = checkbox.cloneNode(true);
        const label = checkbox.nextElementSibling;
        checkbox.parentNode.replaceChild(newCheckbox, checkbox);
        
        // Also clone the label to remove old listeners
        if (label && label.tagName === 'LABEL') {
          const newLabel = label.cloneNode(true);
          label.parentNode.replaceChild(newLabel, label);
        }
        
        newCheckbox.addEventListener('change', (evt) => {
          const checked = newCheckbox.checked;
          const rangeMin = newCheckbox.dataset.rangeMin;
          const rangeMax = newCheckbox.dataset.rangeMax;
          const filterUrl = newCheckbox.dataset.filterUrl;
          
          console.log('[Price Range Checkboxes] Checkbox changed:', {
            index,
            checked,
            rangeMin,
            rangeMax,
            filterUrl
          });
          
          // Store scroll position before navigation
          const scrollY = window.scrollY || window.pageYOffset;
          sessionStorage.setItem('priceFilterScrollPosition', scrollY.toString());
          
          if (checked) {
            // Navigate to the filtered URL
            if (filterUrl) {
              console.log('[Price Range Checkboxes] Navigating to:', filterUrl);
              window.location.href = filterUrl;
            }
          } else {
            // Navigate to clear filter URL
            const clearUrl = newCheckbox.dataset.clearUrl;
            if (clearUrl) {
              console.log('[Price Range Checkboxes] Clearing filter, navigating to:', clearUrl);
              window.location.href = clearUrl;
            }
          }
        });
      });
      
      console.log('[Price Range Checkboxes] Enhancement complete');
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhancePriceRange);
  } else {
    enhancePriceRange();
  }
  
  // Re-initialize after facet filters update (Shopify AJAX)
  document.addEventListener('shopify:section:load', () => {
    console.log('[Price Range Checkboxes] Section loaded, re-initializing');
    setTimeout(enhancePriceRange, 100);
  });
  
  // Listen for facet filter updates
  if (window.location.pathname.includes('/collections/') || window.location.pathname.includes('/search')) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && (node.matches('price-range') || node.querySelector('price-range'))) {
              console.log('[Price Range Checkboxes] Price range element detected, re-initializing');
              setTimeout(enhancePriceRange, 100);
            }
          });
        }
      });
    });
    
    // Observe the facet filters container
    const facetContainer = document.querySelector('facet-filters');
    if (facetContainer) {
      observer.observe(facetContainer, { childList: true, subtree: true });
      console.log('[Price Range Checkboxes] Observing facet filter updates');
    }
  }
  
  // Also run after a short delay to catch dynamically loaded content
  setTimeout(enhancePriceRange, 500);
  
  // Restore scroll position after page load (from checkbox navigation)
  const scrollPosition = sessionStorage.getItem('priceFilterScrollPosition');
  if (scrollPosition) {
    requestAnimationFrame(() => {
      window.scrollTo(0, parseInt(scrollPosition));
      sessionStorage.removeItem('priceFilterScrollPosition');
      console.log('[Price Range Checkboxes] Restored scroll position:', scrollPosition);
    });
  }
})();

